import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticlesComponent } from './articles/articles.component';
import { ArticlesRoutingModule } from './articles-routing.module';
import { UiModule } from '../../ui/ui.module';
import { ListComponent } from './list/list.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { AddEditVariantFormComponent } from './add-edit-variant-form/add-edit-variant-form.component';
import { AddEditVariantModalComponent } from './add-edit-variant-modal/add-edit-variant-modal.component';
import { CoreModule } from '../../core/core.module';
import { AddEditFormulaFormComponent } from './add-edit-formula-form/add-edit-formula-form.component';
import { StorestocksModule } from '../stores-stocks/storestocks.module';
import { SharedModule } from '../../shared/shared.module';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { MhdListComponent } from './mhd-list/mhd-list.component';
import { MhdListPageComponent } from './mhd-list-page/mhd-list-page.component';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';

@NgModule({
  declarations: [
    ArticlesComponent,
    ListComponent,
    AddEditVariantFormComponent,
    AddEditVariantModalComponent,
    AddEditFormulaFormComponent,
    MhdListComponent,
    MhdListPageComponent,
  ],
  imports: [
    CommonModule,
    ArticlesRoutingModule,
    CoreModule,
    UiModule,
    NzListModule,
    NzTabsModule,
    StorestocksModule,
    SharedModule,
    NzStatisticModule,
    NzTooltipDirective
  ],

  exports: [
    AddEditFormulaFormComponent,
    MhdListPageComponent,
  ]
})
export class ArticlesModule { }
